import { render, staticRenderFns } from "./ValidTo.vue?vue&type=template&id=220061ce&scoped=true&"
import script from "./ValidTo.vue?vue&type=script&lang=js&"
export * from "./ValidTo.vue?vue&type=script&lang=js&"
import style0 from "./ValidTo.vue?vue&type=style&index=0&id=220061ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220061ce",
  null
  
)

export default component.exports